import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import UIPageTitle from 'components/UI/PageTitle/PageTitle';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const Profile = React.lazy(() => import('components/Profile/Profile'));

function ScreensUserProfile() {
  return (
    <BaseLayout>
      <DocumentTitle>Profile</DocumentTitle>
      <UIPageTitle>My Account</UIPageTitle>
      <Suspense fallback={<UILoader />}>
        <Profile />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensUserProfile;
